import { BotStarterOpeningUpsertDTO, BotStarterOpeningView } from "@swivl-mono/types";

import { APIService } from "../Service/API.Service";

/** How each Conversation Starter opens, per scope (ENG-3108) — Property Manager v3. */
export class StarterOpeningsAPI {
  static async view(orgId: number, scope: { groupId?: number; locationId?: number }): Promise<BotStarterOpeningView[]> {
    return APIService.Server.get<BotStarterOpeningView[]>(`/starter-openings/org/${orgId}`, scope);
  }

  static async upsert(orgId: number, starterSlug: string, body: BotStarterOpeningUpsertDTO): Promise<BotStarterOpeningView[]> {
    return APIService.Server.put<BotStarterOpeningView[]>(`/starter-openings/org/${orgId}/${encodeURIComponent(starterSlug)}`, body);
  }

  static async remove(orgId: number, starterSlug: string, scope: { groupId?: number; locationId?: number }): Promise<BotStarterOpeningView[]> {
    return APIService.Server.delete<BotStarterOpeningView[]>(`/starter-openings/org/${orgId}/${encodeURIComponent(starterSlug)}`, scope);
  }
}
